module.exports = __webpack_public_path__ + "img/emty.4d0e30cf.png";